import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { ChannelTypes } from 'conversations-internal-schema/constants/ChannelTypes';
import { Fragment } from 'react';
import setIn from 'transmute/setIn';
import { checkIsRoutingRules, getAssignByAvailability } from '../utils/getAssignByAvailability';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import RuleBox from './RuleBox';
import I18n from 'I18n';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledCheckbox = styled(UICheckbox).withConfig({
  displayName: "AssignToAvailableCheckbox__StyledCheckbox",
  componentId: "j0b2hj-0"
})(["width:fit-content;"]);
const checkIsAssignableChannel = (channelType = '') => [ChannelTypes.EMAIL, ChannelTypes.FORMS, ChannelTypes.CHAT].includes(channelType);
const checkIsReadOnlyChannel = (channelType = '') => [ChannelTypes.CHAT].includes(channelType);
const AssignToAvailableUpgrade = ({
  show
}) => {
  if (!show) {
    return null;
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "right",
    title:
    /*#__PURE__*/
    // TODO: also disable for users that can assign to available but are not admins
    _jsx(FormattedMessage, {
      message: "routing-ui.routingRules.filterAvailableCheckbox.upgrade"
    }),
    children: /*#__PURE__*/_jsx(UILockBadge, {
      className: "m-left-2"
    })
  });
};
AssignToAvailableUpgrade.displayName = 'AssignToAvailableUpgrade';
const AssignToAvailableCheckbox = ({
  channelType,
  disabled,
  onRuleUpdate,
  routingRules,
  hasAssignToAvailable = true,
  HeaderWrapper = Fragment
}) => {
  const showAssignByAvailability = checkIsAssignableChannel(channelType) && checkIsRoutingRules(routingRules);
  if (!showAssignByAvailability) {
    return null;
  }
  return /*#__PURE__*/_jsx(RuleBox, {
    label: /*#__PURE__*/_jsx(HeaderWrapper, {
      children: I18n.text('routing-ui.routingRules.filterAvailableCheckbox.title')
    }),
    className: "selectTypeRow",
    children: /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.routingRules.filterAvailableCheckbox.tooltip"
      }),
      disabled: !checkIsReadOnlyChannel(channelType),
      children: /*#__PURE__*/_jsxs(StyledCheckbox, {
        checked: getAssignByAvailability(routingRules),
        disabled: !hasAssignToAvailable || disabled,
        readOnly: checkIsReadOnlyChannel(channelType),
        "data-test-id": "routing-assign-availability-checkbox",
        description: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.routingRules.filterAvailableCheckbox.description"
          })
        }),
        onChange: ({
          target: {
            checked
          }
        }) => {
          onRuleUpdate(setIn(['shouldFilterToAvailable'], checked, routingRules));
        },
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.routingRules.filterAvailableCheckbox.label"
        }), /*#__PURE__*/_jsx(AssignToAvailableUpgrade, {
          show: !hasAssignToAvailable
        })]
      })
    })
  });
};
AssignToAvailableCheckbox.displayName = 'AssignToAvailableCheckbox';
export default AssignToAvailableCheckbox;